import { Link } from 'react-router-dom';
import { rankingCards } from '../../../mocks/ranking-cards';

export default function TopPickCard() {
  const topCard = rankingCards[0];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-700 relative overflow-hidden">
      {/* 装飾要素 */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-emerald-400/10 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-8 sm:mb-12">
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-yellow-400 text-gray-900 text-xs sm:text-sm font-bold px-4 sm:px-5 py-2 rounded-full shadow-lg mb-3 sm:mb-4">
            <i className="ri-trophy-fill text-base sm:text-lg"></i>
            編集部イチオシ
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white tracking-tight px-4">
            今すぐ選ぶならこの1枚
          </h2>
        </div>

        {/* カード */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="p-6 sm:p-8 md:p-10">
            <div className="flex flex-col lg:flex-row items-center gap-6 sm:gap-8 lg:gap-10">
              {/* カード画像 */}
              <div className="relative flex-shrink-0 w-full sm:w-auto">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-100 to-emerald-100 rounded-2xl blur-xl opacity-50"></div>
                <div className="relative w-full sm:w-56 h-32 sm:h-36 bg-gradient-to-br from-gray-50 to-white rounded-2xl p-4 sm:p-5 flex items-center justify-center shadow-lg border border-gray-100">
                  <img
                    src={topCard.logo}
                    alt={topCard.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              {/* カード情報 */}
              <div className="flex-1 text-center lg:text-left w-full">
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  <Link to={topCard.detailUrl} className="hover:text-teal-600 hover:underline transition-colors cursor-pointer">
                    {topCard.name}
                  </Link>
                </h3>
                
                {/* スペック */}
                <div className="flex flex-col sm:flex-row flex-wrap justify-center lg:justify-start gap-3 sm:gap-4 mb-6">
                  <div className="flex items-center justify-center gap-2 bg-teal-50 px-4 py-2 rounded-xl">
                    <i className="ri-percent-line text-teal-600 text-base sm:text-lg"></i>
                    <span className="text-teal-700 font-bold text-sm sm:text-base">還元率 {topCard.returnRate}</span>
                  </div>
                  <div className="flex items-center justify-center gap-2 bg-emerald-50 px-4 py-2 rounded-xl">
                    <i className="ri-price-tag-3-line text-emerald-600 text-base sm:text-lg"></i>
                    <span className="text-emerald-700 font-bold text-sm sm:text-base">{topCard.annualFee}</span>
                  </div>
                </div>

                {/* メリット */}
                <div className="space-y-3 mb-6 sm:mb-8">
                  <div className="flex items-start gap-3 bg-gradient-to-r from-orange-50 to-amber-50 p-3 sm:p-4 rounded-xl">
                    <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 bg-gradient-to-br from-orange-500 to-red-500 text-white rounded-lg flex items-center justify-center text-xs sm:text-sm font-bold shadow-md">1</span>
                    <p className="text-gray-700 font-medium text-sm sm:text-base text-left">コンビニ・飲食店でスマホタッチ決済で最大7%還元</p>
                  </div>
                  <div className="flex items-start gap-3 bg-gradient-to-r from-orange-50 to-amber-50 p-3 sm:p-4 rounded-xl">
                    <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 bg-gradient-to-br from-orange-500 to-red-500 text-white rounded-lg flex items-center justify-center text-xs sm:text-sm font-bold shadow-md">2</span>
                    <p className="text-gray-700 font-medium text-sm sm:text-base text-left">年会費永年無料で維持コストゼロ</p>
                  </div>
                  <div className="flex items-start gap-3 bg-gradient-to-r from-orange-50 to-amber-50 p-3 sm:p-4 rounded-xl">
                    <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 bg-gradient-to-br from-orange-500 to-red-500 text-white rounded-lg flex items-center justify-center text-xs sm:text-sm font-bold shadow-md">3</span>
                    <p className="text-gray-700 font-medium text-sm sm:text-base text-left">最短10秒でカード番号発行、すぐに使える</p>
                  </div>
                </div>
              </div>

              {/* CTAボタン */}
              <div className="flex flex-col gap-3 sm:gap-4 w-full lg:w-auto">
                <a
                  href={topCard.officialUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold px-8 sm:px-10 py-4 sm:py-5 rounded-2xl transition-all shadow-xl shadow-orange-500/30 hover:shadow-2xl hover:shadow-orange-500/40 transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  <i className="ri-external-link-line text-lg sm:text-xl"></i>
                  公式キャンペーンを確認
                </a>
                <a
                  href={topCard.detailUrl}
                  className="inline-flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-2xl transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}